import { useAuth } from '@/hooks/useAuth'
import { useEffect, useState } from 'react'

export default function AuthDebug() {
  const { user, loading, isAdmin, logout } = useAuth()
  const [claims, setClaims] = useState<any>(null)
  const [isVisible, setIsVisible] = useState(true)

  useEffect(() => {
    const checkClaims = async () => {
      if (user) {
        try {
          console.log('🔍 [AuthDebug] Checking claims for user:', user.uid)
          const tokenResult = await user.getIdTokenResult(true) // Force refresh
          console.log('🔍 [AuthDebug] Token result:', tokenResult.claims)
          setClaims(tokenResult.claims)
        } catch (error) {
          console.error('🔍 [AuthDebug] Error getting claims:', error)
        }
      } else {
        setClaims(null)
      }
    }

    checkClaims()
  }, [user])

  const handleRefreshToken = async () => {
    if (user) {
      try {
        console.log('🔄 [AuthDebug] Forcing token refresh...')
        await user.getIdToken(true) // Force refresh
        const tokenResult = await user.getIdTokenResult(true)
        console.log('🔄 [AuthDebug] New token claims:', tokenResult.claims)
        setClaims(tokenResult.claims)
        
        // Trigger a re-check of admin status
        window.location.reload()
      } catch (error) {
        console.error('🔄 [AuthDebug] Error refreshing token:', error)
      }
    }
  }

  const handleLogout = async () => {
    try {
      await logout()
      window.location.href = '/login'
    } catch (error) {
      console.error('Logout error:', error)
    }
  }

  // Solo mostrar si el usuario está autenticado Y es admin Y está visible
  if (!user || !isAdmin || loading) {
    return null
  }

  // Si está oculto, mostrar solo un botón pequeño para volver a mostrarlo
  if (!isVisible) {
    return (
      <button
        onClick={() => setIsVisible(true)}
        style={{
          position: 'fixed',
          bottom: '20px',
          right: '20px',
          background: 'rgba(255,68,68,0.8)',
          color: 'white',
          border: 'none',
          borderRadius: '50%',
          width: '50px',
          height: '50px',
          cursor: 'pointer',
          fontSize: '20px',
          zIndex: 9999,
          boxShadow: '0 4px 12px rgba(255,68,68,0.3)'
        }}
        title="Mostrar panel de debug"
      >
        🐛
      </button>
    )
  }

  return (
    <div style={{
      position: 'fixed',
      top: '100px',
      right: '10px',
      background: 'rgba(0,0,0,0.9)',
      color: 'white',
      padding: '20px',
      borderRadius: '12px',
      fontSize: '14px',
      zIndex: 9999,
      maxWidth: '450px',
      fontFamily: 'monospace',
      border: '2px solid #ff4444'
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
        <h3 style={{ margin: '0', color: '#ff4444' }}>⚠️ AUTH DEBUG ⚠️</h3>
        <button
          onClick={() => setIsVisible(false)}
          style={{
            background: 'transparent',
            border: '1px solid #ff4444',
            color: '#ff4444',
            borderRadius: '50%',
            width: '24px',
            height: '24px',
            cursor: 'pointer',
            fontSize: '12px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
          title="Ocultar panel de debug"
        >
          ✕
        </button>
      </div>
      
      <div style={{ marginBottom: '15px', padding: '10px', backgroundColor: 'rgba(255,68,68,0.1)', borderRadius: '6px' }}>
        <div><strong>Current Status:</strong></div>
        <div>Loading: {loading.toString()}</div>
        <div>User: {user?.email || 'null'}</div>
        <div style={{ color: '#ff4444' }}><strong>Is Admin: {isAdmin.toString()}</strong></div>
        <div>User ID: {user?.uid || 'null'}</div>
      </div>

      <div style={{ marginBottom: '15px' }}>
        <div><strong>Claims:</strong></div>
        <pre style={{ fontSize: '11px', marginTop: '5px', backgroundColor: 'rgba(255,255,255,0.1)', padding: '8px', borderRadius: '4px' }}>
          {JSON.stringify(claims, null, 2)}
        </pre>
      </div>
      
      <button 
        onClick={handleLogout}
        style={{
          width: '100%',
          padding: '12px',
          backgroundColor: '#ff4444',
          color: 'white',
          border: 'none',
          borderRadius: '6px',
          cursor: 'pointer',
          fontSize: '16px',
          fontWeight: 'bold',
          marginBottom: '10px'
        }}
      >
        🚪 LOGOUT CURRENT USER
      </button>
      
      <button 
        onClick={handleRefreshToken}
        style={{
          width: '100%',
          padding: '12px',
          backgroundColor: '#4444ff',
          color: 'white',
          border: 'none',
          borderRadius: '6px',
          cursor: 'pointer',
          fontSize: '16px',
          fontWeight: 'bold',
          marginBottom: '15px'
        }}
      >
        🔄 REFRESH TOKEN
      </button>
      
      <div style={{ 
        padding: '15px', 
        backgroundColor: 'rgba(0,255,136,0.1)', 
        borderRadius: '6px',
        border: '1px solid #00ff88'
      }}>
        <div style={{ color: '#00ff88', fontWeight: 'bold', marginBottom: '8px' }}>✅ Use These Credentials:</div>
        <div style={{ marginBottom: '5px' }}><strong>Email:</strong> ceo@royalsoftware.com.co</div>
        <div><strong>Password:</strong> ingeniux</div>
      </div>
    </div>
  )
}
